// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import {
  deleteNotificationDestination,
  DeleteNotificationDestinationRequest,
} from 'services/WebHooksService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useDeleteNotificationDestinationMutation = () => {
  return useMutation({
    mutationFn: deleteNotificationDestination,
    onError(error: BaseErrorResponse, data: DeleteNotificationDestinationRequest) {
      logSentryError('Error from useDeleteWebhookDestinationMutation', error, data)
    },
  })
}
